import React, { useState } from 'react';
import { Row, Col, Tab, Nav } from 'react-bootstrap';
import { ActivitiesMarkingsReport, activitiesMarkingsColumns } from '../../components/CompanyReport';
import { Icon } from '../../components';

const ActivitiesMarkingsReportIndex = () => {
  const [moreData, setMoreData] = useState(false);
  const [key, setKey] = useState('activities-marking-report');

  return (
    <>
      <Row className="mt-2">
        <Col>
          <h2 className="mb-2 mt-2">Informes</h2>
        </Col>
      </Row>
      <Tab.Container id="activities-markings-index.tabs" activeKey={key} onSelect={k => setKey(k)} mountOnEnter>
        <Nav variant="pills">
          <Nav.Item>
            <Nav.Link className="mb-1" eventKey="activities-marking-report">
              <Icon icon="location" />
              Registro de Marca
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="activities-marking-report">
            <ActivitiesMarkingsReport
              columns={activitiesMarkingsColumns}
              moreData={moreData}
              setMoreData={setMoreData}
            />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </>
  );
};

export default ActivitiesMarkingsReportIndex;
